import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`	
  a {
    color: var(--color-secondary);
	}

	.main-content {
		margin-left: auto;
		margin-right: auto;
		max-width: 45rem;
		padding: 2.625rem 1.3125rem;
	}

	/* DEFAULT STYLES */

	html {
		font-size: 16px;
		--font-body: 'Merriweather';
		--font-heading: 'Montserrat';
		--font-weight-normal: 500;
		--font-weight-bold: 700;
		--font-weight-extra-bold: 800;
		--color-dark-background: hsl(220, 100%, 9%);
		--default-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
	}

	article,
	aside,
	details,
	figcaption,
	figure,
	footer,
	header,
	main,
	menu,
	nav,
	section,
	summary {
		display: block;
	}

	audio,
	canvas,
	progress,
	video {
		display: inline-block;
	}

	audio:not([controls]) {
		display: none;
		height: 0;
	}

	progress {
		vertical-align: baseline;
	}

	[hidden],
	template {
		display: none;
	}

	a {
		background-color: transparent;
		-webkit-text-decoration-skip: objects;
	}

	a:active,
	a:hover {
		outline-width: 0;
	}

	abbr[title] {
		border-bottom: none;
		text-decoration: underline;
		text-decoration: underline dotted;
	}

	b,
	strong {
		font-weight: inherit;
		font-weight: bolder;
	}

	dfn {
		font-style: italic;
	}

	mark {
		background-color: #ff0;
		color: #000;
	}

	small {
		font-size: 80%;
	}

	sub,
	sup {
		font-size: 75%;
		line-height: 0;
		position: relative;
		vertical-align: baseline;
	}

	sub {
		bottom: -0.25em;
	}

	sup {
		top: -0.5em;
	}

	img {
		border-style: none;
	}

	svg:not(:root) {
		overflow: hidden;
	}

	code,
	kbd,
	pre,
	samp {
		font-family: monospace, monospace;
		font-size: 1em;
	}

	figure {
		margin: 1em 40px;
	}

	hr {
		box-sizing: content-box;
		height: 0;
		overflow: visible;
	}

	button,
	input,
	optgroup,
	select,
	textarea {
		font: inherit;
		margin: 0;
	}

	optgroup {
		font-weight: 700;
	}

	button,
	input {
		overflow: visible;
	}

	button,
	select {
		text-transform: none;
	}

	[type='reset'],
	[type='submit'],
	button,
	html [type='button'] {
		-webkit-appearance: button;
	}

	[type='button']::-moz-focus-inner,
	[type='reset']::-moz-focus-inner,
	[type='submit']::-moz-focus-inner,
	button::-moz-focus-inner {
		border-style: none;
		padding: 0;
	}

	[type='button']:-moz-focusring,
	[type='reset']:-moz-focusring,
	[type='submit']:-moz-focusring,
	button:-moz-focusring {
		outline: 1px dotted ButtonText;
	}

	fieldset {
		border: 1px solid silver;
		margin: 0 2px;
		padding: 0.35em 0.625em 0.75em;
	}

	legend {
		box-sizing: border-box;
		color: inherit;
		display: table;
		max-width: 100%;
		padding: 0;
		white-space: normal;
	}

	textarea {
		overflow: auto;
	}

	[type='checkbox'],
	[type='radio'] {
		box-sizing: border-box;
		padding: 0;
	}

	[type='number']::-webkit-inner-spin-button,
	[type='number']::-webkit-outer-spin-button {
		height: auto;
	}

	[type='search'] {
		-webkit-appearance: textfield;
		outline-offset: -2px;
	}

	[type='search']::-webkit-search-cancel-button,
	[type='search']::-webkit-search-decoration {
		-webkit-appearance: none;
	}

	::-webkit-input-placeholder {
		color: inherit;
		opacity: 0.54;
	}

	::-webkit-file-upload-button {
		-webkit-appearance: button;
		font: inherit;
	}

	* {
		box-sizing: inherit;
	}

	*:before {
		box-sizing: inherit;
	}

	*:after {
		box-sizing: inherit;
	}

	body {
		margin: 0;
		font-weight: 500;
		line-height: 30px;
		font-kerning: normal;
		letter-spacing: 0.01rem;
		/* word-wrap: break-word; */
		color: var(--color-text);
		background: var(--color-background);
		-webkit-font-smoothing: antialiased;
		font-smoothing: antialiased;
		font-family: 'Merriweather', Knile, Futura, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
		transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
		-moz-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
		-ms-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
		-webkit-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
		font-feature-settings: 'kern', 'liga', 'clig', 'calt';
	}

	hgroup {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
	}

	ul {
		margin-left: 1.75rem;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
		list-style-position: outside;
		list-style-image: none;
		list-style: disc;
	}

	ol {
		margin-left: 1.75rem;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
		list-style-position: outside;
		list-style-image: none;
	}

	dl {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
	}

	dd {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
	}

	p {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 0;
		/* hyphens: auto; */
	}

	blockquote {
		margin-left: -1.75rem;
		margin-right: 1.75rem;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 1.42188rem;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: 1.75rem;
		font-size: 1.20112rem;
		line-height: 1.75rem;
		color: inherit;
		font-style: italic;
		border-left: 0.32813rem solid hsla(0, 0%, 0%, 0.9);
		border-left-color: inherit;
		opacity: 0.8;
	}

	hr {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		margin-bottom: calc(1.75rem - 1px);
		background: var(--hr);
		border: none;
		height: 1px;
	}

	b {
		font-weight: 700;
	}

	strong {
		font-weight: 700;
	}

	dt {
		font-weight: 700;
	}

	th {
		font-weight: 700;
	}

	li {
		margin-bottom: calc(1.75rem / 2);
	}

	ol li {
		padding-left: 0;
	}

	ul li {
		padding-left: 0;
	}

	li > ol {
		margin-left: 1.75rem;
		margin-bottom: calc(1.75rem / 2);
		margin-top: calc(1.75rem / 2);
	}

	li > ul {
		margin-left: 1.75rem;
		margin-bottom: calc(1.75rem / 2);
		margin-top: calc(1.75rem / 2);
	}

	blockquote *:last-child {
		margin-bottom: 0;
	}

	li *:last-child {
		margin-bottom: 0;
	}

	p *:last-child {
		margin-bottom: 0;
	}

	li > p {
		margin-bottom: calc(1.75rem / 2);
	}

	code {
		font-size: 0.85rem;
		line-height: 1.75rem;
	}

	kbd {
		font-size: 0.85rem;
		line-height: 1.75rem;
	}

	samp {
		font-size: 0.85rem;
		line-height: 1.75rem;
	}

	abbr {
		border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
		cursor: help;
	}

	acronym {
		border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
		cursor: help;
	}

	abbr[title] {
		border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
		cursor: help;
		text-decoration: none;
	}

	thead {
		text-align: left;
	}

	td,
	th {
		text-align: left;
		border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);
		font-feature-settings: 'tnum';
		-moz-font-feature-settings: 'tnum';
		-ms-font-feature-settings: 'tnum';
		-webkit-font-feature-settings: 'tnum';
		padding-left: 1.16667rem;
		padding-right: 1.16667rem;
		padding-top: 0.875rem;
		padding-bottom: calc(0.875rem - 1px);
	}

	th:first-child,
	td:first-child {
		padding-left: 0;
	}

	th:last-child,
	td:last-child {
		padding-right: 0;
	}

	blockquote > :last-child {
		margin-bottom: 0;
	}

	blockquote cite {
		font-size: 1rem;
		line-height: 1.75rem;
		color: hsla(0, 0%, 0%, 0.9);
		font-weight: 400;
	}

	blockquote cite:before {
		content: '— ';
	}

	ul,
	ol {
		margin-left: 0;
	}

	@media only screen and (max-width: 480px) {
		ul,
		ol {
			margin-left: 1.75rem;
		}
		blockquote {
			margin-left: -1.3125rem;
			margin-right: 0;
			padding-left: 0.98438rem;
		}
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-left: 0;
		margin-right: 0;
		padding-top: 0;
		padding-left: 0;
		padding-right: 0;
		padding-bottom: 0;
		line-height: 1.4;
		font-family: var(--font-heading);
		font-weight: var(--font-weight-extra-bold);
		text-rendering: optimizeLegibility;
	}

	a {
		line-height: 26px;
		text-decoration: none;
		color: var(--color-primary);
		box-shadow: 0 1px 0 0 currentColor;
		transition: color 200ms ease 0ms;
	}

	a:hover {
		transition: color 200ms ease 150ms;
	}

	h1 a,
	h2 a,
	h3 a,
	h4 a,
	h5 a,
	h6 a,
	a:hover,
	a:active {
		box-shadow: none;
	}

	mark,
	ins {
		background: #007acc;
		color: white;
		padding: 0.10938rem 0.21875rem;
		text-decoration: none;
	}

	a.gatsby-resp-image-link {
		box-shadow: none;
	}

	a.anchor {
		box-shadow: none;
	}

	a.anchor svg[aria-hidden='true'] {
		stroke: var(--textLink);
	}

	p code {
		font-size: 1rem;
	}

	h1 code,
	h2 code,
	h3 code,
	h4 code,
	h5 code,
	h6 code {
		font-size: inherit;
	}

	li code {
		font-size: 1rem;
	}

	blockquote.translation {
		font-size: 1em;
	}

	/* DEFAULT STYLES END */

	/* body.light {
		--bg: #fff;
		--bg-secondary: #f9fafb;
		--header: var(--dark-pink);
		--textNormal: #222;
		--textTitle: #222;
		--textLink: var(--dark-pink);
		--hr: rgba(0, 0, 0, 0.2);
		--inlineCode-bg: rgba(255, 229, 100, 0.2);
		--inlineCode-text: #1a1a1a;
		--form-shadow: 0 2px 15px 0 rgba(210, 214, 220, 0.5);
	} */

	/* body.dark {
		-webkit-font-smoothing: antialiased;
		--bg: #160f30;
		--bg-secondary: #363c48;
		--header: #fff;
		--textNormal: hsla(0, 0%, 100%, 0.88);
		--textTitle: #fff;
		--textLink: var(--light-pink);
		--hr: hsla(0, 0%, 100%, 0.2);
		--inlineCode-bg: rgba(115, 124, 153, 0.2);
		--inlineCode-text: #e6e6e6;
		--form-shadow: 0 2px 15px 0 rgba(26, 26, 27, 0.637);
	} */

	/* My Colors */
	/*
	--light-pink: #e0acd5;
	--dark-bg: #14213D;
	--dark-bg: #202040;
	--dark-bg: #160f30;
	--textLink: #8f1383
	--textLink: #b5076b;
	*/

	/* 
		DARK MODE HEADING OPTIONS
		#c060a1;
		#e0acd5;
		#e85f99;
	*/

	.nav-link {
		color: var(--textNormal);
	}

	.nav-link:hover {
		color: var(--textLink);
	}

	.heading {
		font-family: var(--font-heading);
		font-weight: var(--font-weight-extra-bold);
	}

	.default-transition {
		transition: var(--default-transition);
	}

	.number, .date {
		font-family: var(--font-heading);
	}

	.border-1 {
		border-width: 1px;
	}

	.border-t-1 {
		border-top-width: 1px;
	}

	.border-b-1 {
		border-bottom-width: 1px;
	}

	.border-gray-100	{border-color: var(--color-gray-100);	}
	.border-gray-200	{border-color: var(--color-gray-200);	}
	.border-gray-300	{border-color: var(--color-gray-300);	}
	.border-gray-400	{border-color: var(--color-gray-400);	}
	.border-gray-500	{border-color: var(--color-gray-500);	}
	.border-gray-600	{border-color: var(--color-gray-600);	}
	.border-gray-700	{border-color: var(--color-gray-700);	}
	.border-gray-800	{border-color: var(--color-gray-800);	}
	.border-gray-900	{border-color: var(--color-gray-900);	}
	.border-gray-1000	{border-color: var(--color-gray-1000);	}

	.gradient-text {
		background: linear-gradient(270deg,var(--color-tertiary),var(--color-secondary));
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`;

export default GlobalStyles;
